import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";


const Register = () => {

    
let history = useHistory()

    const [input, setInput] = useState({
        name : "",
        email : "",
        password : ""
    })

    const handleChange = (e) => {

        let {value, name} = e.target

        setInput ({...input, [name] : value})
    }

    const handleRegister = (e) => {
        e.preventDefault()
        console.log(input)

        let {name, email, password} = input

        axios.post('https://backendexample.sanbersy.com/api/register' , {name, email, password}
        ).then((res)=>{
       
        history.push('/login')
        }).catch((res) => { 

        let tmp = Object.keys(JSON.parse(res.response.data))
        
        for(let i =0; i < tmp.length; i++) {
            if(tmp[i] === "password") {
                let {password} = JSON.parse(res.response.data)
                alert(password)
            } else if (tmp[i] === "email") {
                let {email} = JSON.parse(res.response.data)
                alert(email)
            }
        }    
        })
    
    }

    return (
        <div>
            <form onSubmit={handleRegister}  style={{marginTop: "100px"}}>
                <input required value={input.name} onChange={handleChange} name="name" type="text" placeholder="Name" />
                <input required value={input.email} onChange={handleChange} name="email" type="email" placeholder="Email" />
                <input required value={input.password} onChange={handleChange} name="password" type="password" placeholder="Password"/>
                <input type="submit" value="Register" />
            </form>
        </div>
    )
}

export default Register